/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type api_v2_analytics_reports_ReportExport = {
    file_type: api_v2_analytics_reports_ReportExport.file_type;
};
export namespace api_v2_analytics_reports_ReportExport {
    export enum file_type {
        CSV = 'csv',
        XLSX = 'xlsx',
    }
}

